//////////////////////////////////////////////////
//// Constant:
//////////////////////////////////////////////////
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
export const DEFAULT_RESPECT_USER_MOTION_PREFERENCE = false;
